import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Components
import { HeaderComponent } from "../header/header.component";
import { HeaderStaticComponent } from "../header-static/header-static.component";
import { FooterStaticComponent } from "../footer-static/footer-static.component";
import { CarouselComponent } from "../carousel/carousel.component";
import { UnauthorisedErrorHandleComponent } from "../unauthorised-error-handle/unauthorised-error-handle.component";
import { ListOfCandidatesComponent } from "../assessments-module/list-of-candidates/list-of-candidates.component";
import { MathjaxComponent } from "./mathjax/mathjax.component";
import { IntlTelInputDirective } from "./directives/intl-tel-input.directive";

// Import the standalone component
import { ArchiveCatModalComponent } from "../superadmin-qb-module/archive-cat-modal/archive-cat-modal.component";

// Pipes
import { FilterPipe } from "../filter.pipe";

// Third-party modules
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { provideNgxMask } from "ngx-mask";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from "@angular/material/core";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgImageSliderModule } from "ng-image-slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DeleteDialogComponent } from "./components/delete-dialog/delete-dialog.component";
import { CancelDialogComponent } from "./components/cancel-dialog/cancel-dialog.component";
import { StatusDialogComponent } from "./components/status-dialog/status-dialog.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { OnlyNumberDirective } from "./directives/only-number.directive";
import { NodatafoundComponent } from "./components/nodatafound/nodatafound.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";
import { SubmitConfirmationComponent } from "./components/submit-confirmation/submit-confirmation.component";
import { ErrorPageComponent } from "./components/error-page/error-page.component";

@NgModule({
  imports: [
    CommonModule,
    NgMultiSelectDropDownModule.forRoot(),
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxIntlTelInputModule,
    NgxUiLoaderModule,
    MatSelectModule,
    NgSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatStepperModule,
    MatTabsModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    ArchiveCatModalComponent,
    NgImageSliderModule,
    HeaderComponent,
    // ListOfCandidatesComponent
  ],
  declarations: [
    HeaderStaticComponent,
    FooterStaticComponent,
    CarouselComponent,
    UnauthorisedErrorHandleComponent,
    FilterPipe,
    MathjaxComponent,
    IntlTelInputDirective,
    OnlyNumberDirective,
    DeleteDialogComponent,
    CancelDialogComponent,
    StatusDialogComponent,
    NodatafoundComponent,
    SubmitConfirmationComponent,
    ErrorPageComponent,
  ],
  exports: [
    HeaderComponent,
    HeaderStaticComponent,
    FooterStaticComponent,
    CarouselComponent,
    UnauthorisedErrorHandleComponent,
    CancelDialogComponent,
    FilterPipe,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    BsDatepickerModule,
    NgxIntlTelInputModule,
    NgxUiLoaderModule,
    MatSelectModule,
    NgSelectModule,
    MatTabsModule,
    MatMenuModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatInputModule,
    MatAutocompleteModule,
    DeleteDialogComponent,
    ErrorPageComponent,
    SubmitConfirmationComponent,
    NodatafoundComponent,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatNativeDateModule,
    NgMultiSelectDropDownModule,
    MatStepperModule,
    // ListOfCandidatesComponent,

    ArchiveCatModalComponent,
    NgImageSliderModule,
    MathjaxComponent,
    IntlTelInputDirective,
    OnlyNumberDirective,
  ],
  providers: [provideNgxMask()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
